import { Card } from 'components/atoms';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { IAdvance } from 'services/advance/types';
import { formatCurrency } from 'utils/global/currency.utils';
import { handleDownloadFile } from 'utils/global/linkToUrl.utils';

const RepaymentsTable = () => {
  const { values, status } = useFormikContext<IAdvance>();
  const { t } = useTranslation();

  const getRepaymentFile = (url: string): void => {
    handleDownloadFile(url);
  };

  return (
    <ListWrapper
      style={{ paddingBottom: 100 }}
      items={values.repayments}
      isLoading={status.isLoading}
      item={(repayment, key) => (
        <Card
          key={key}
          header={repayment.repaymentSource.name}
          description={repayment.repaymentDocument.number.value}
          status={
            <div
              className='flex w-max font-bold items-center gap-4'
              style={{ fontSize: 18 }}>
              {formatCurrency(repayment.amount)}
              {/* <Button
                type='button'
                isClear
                variant={BUTTON_VARIANT.black}
                onlyIcon
                onClick={() =>
                  getRepaymentFile(repayment.repaymentDocument.fileName)
                }>
                <Button.Icon icon={<PiDownload />} />
                <Button.Text text={t('button.download')} />
              </Button> */}
            </div>
          }
        />
      )}
    />
    // <Table
    //   id={"RepaymentsTable"}
    //   data={{ nodes: values.repayments }}
    //   columns={[
    //     {
    //       label: t("input.label.date"),
    //       renderCell: (item: any) => (
    //         <TableItem>
    //           <TableItem.Text
    //             text={`${formatDateAndHour(item.repaymentDate)}`}
    //           />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //     {
    //       label: t("input.label.amount"),
    //       renderCell: (item: any) => (
    //         <TableItem>
    //           <TableItem.Currency text={formatCurrency(item.amount)} />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //     {
    //       label: t("input.label.repaymentSource"),
    //       renderCell: (item: any) => (
    //         <TableItem>
    //           <TableItem.Text text={item.repaymentSource.name} />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //     {
    //       label: t("input.label.repaymentDocumentNumber"),
    //       renderCell: (item: any) => (
    //         <TableItem>
    //           <TableItem.Text text={`${item.repaymentDocument.number.value}`} />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //     {
    //       label: t("input.label.repaymentDocumentFilename"),
    //       renderCell: (item: any) => (
    //         <TableItem>
    //           <Button
    //             type="button"
    //             isClear
    //             variant={BUTTON_VARIANT.black}
    //             onlyIcon
    //             onClick={() =>
    //               getRepaymentFile(item.repaymentDocument.fileName)
    //             }
    //           >
    //             <Button.Icon icon={<PiDownload />} />
    //             <Button.Text text={t("button.download")} />
    //           </Button>
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //   ]}
    // />
  );
};

export default RepaymentsTable;
